  
import { combineReducers, createStore } from 'redux'
import collapsed from './collapsed'
import isLogin from './isLogin'
import user from './user'

const store = createStore(combineReducers({ collapsed, isLogin, user }))

export default store
